import { render, staticRenderFns } from "./FormEditBuilder.vue?vue&type=template&id=04124710&scoped=true&"
import script from "./FormEditBuilder.vue?vue&type=script&lang=js&"
export * from "./FormEditBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormEditBuilder.vue?vue&type=style&index=0&id=04124710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04124710",
  null
  
)

export default component.exports